import { isNot } from '@ipfabric/utils/fp/comparison';

/**
 * Toggle element presence - add it when it is not in the array, remove otherwise
 */
export const toggleArrayElement =
  <T,>(element: T) =>
  (array: T[]): T[] => {
    if (array.includes(element)) {
      return array.filter(isNot(element));
    }
    return [...array, element];
  };
